export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12081.450a570b.jpg";